import React from 'react';

import { awsConfig } from '../aws.config';
import AppRoutes from '../routes';

import { Amplify } from 'aws-amplify';

Amplify.configure(awsConfig);

const App: React.FC = (): React.ReactElement => {
  return <AppRoutes />;
};

export default App;
